import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import { exchangeToken, authChecked } from '../actions/associatesActions';
import { setTenantId as setAppTenant } from '../actions/appActions';
import axios from 'axios';
import { getQueryString } from '../helpers/url';

const Auth = () => {
  const dispatch = useDispatch();
  const [tenantId, setTenantId] = useState(null);

  const fetchTenant = async () => {
    let tenant = null;
    try {
      const welletApi = process.env.REACT_APP_SALES_API_URL;
      const response = await axios.get(`${welletApi}/auth/tenant`);
      tenant = response.data;
    } catch (error) {
      console.error(error);
    }

    setTenantId(tenant);
    dispatch(setAppTenant(tenant));

    return tenant;
  };

  useEffect(() => {
    if (!tenantId) {
      fetchTenant();
    }
  }, [tenantId]);

  return tenantId ? <AuthWithTenant tenantId={tenantId} /> : null;
};

const AuthWithTenant = ({ tenantId }) => {
  const externalAppToken = getQueryString('wlToken');
  const dispatch = useDispatch();
  const history = useHistory();
  const auth = getAuth();
  auth.tenantId = tenantId;

  const [user] = useAuthState(auth);

  const checkExternalAppToken = async () => {
    const welletApi = process.env.REACT_APP_SALES_API_URL;
    const response = await axios.get(
      `${welletApi}/users/external-app/token?token=${externalAppToken}`,
    );
    if (response.data.isValid) {
      const userCredentials = await signInWithCustomToken(auth, response.data.customToken);
      exchangeToken(
        dispatch,
        userCredentials.user,
        () => {},
        history,
        window.decodeURIComponent(externalAppToken),
      );
    }
  };

  useEffect(() => {
    if (externalAppToken) {
      checkExternalAppToken();
    } else if (auth._isInitialized && !user) {
      dispatch(authChecked());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth._isInitialized]);

  useEffect(() => {
    if (user && !externalAppToken) {
      exchangeToken(dispatch, user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, externalAppToken]);

  return null;
};

export default Auth;
